jQuery(function($) {
	$(document).on("click", ".quantity .minus", function() {
		var wrapper = $(this).parent();
		try {
			wrapper.find('input[type=number]').get(0).stepDown();
			wrapper.find('input[type=number]').change();
		} catch(e) {
			var value = (parseInt(wrapper.find('input[type=number]').val())-1);
			wrapper.find('input[type=number]').val((value>=1 ? value : 1));
			wrapper.find('input[type=number]').change();
		}
	});
	$(document).on("click", ".quantity .plus", function() {
		var wrapper = $(this).parent();
		try {
			wrapper.find('input[type=number]').get(0).stepUp();
			wrapper.find('input[type=number]').change();
		} catch(e) {
			var value = (parseInt(wrapper.find('input[type=number]').val())+1);
			wrapper.find('input[type=number]').val(value);
			wrapper.find('input[type=number]').change();
		}
	});

	$(window).scroll(function(){
		// if($(this).scrollTop()<=200) {
		// 	$('.scrollup').hide();
		// } else {
		// 	$('.scrollup').show();
		// }

		

	});

	

	//Wishlist counter
	function renderWishlistCounter(){
		$(".header .wishlist .count").each(function(){
			var element = this;
			window._swat.renderWishlistCount(element, function(cnt, elem){
			});
		});
	}
	if(!window._swat){
		if(!window.SwymCallbacks){
			window.SwymCallbacks = [];
		}
		window.SwymCallbacks.push(renderWishlistCounter);
	}else{
		renderWishlistCounter();
	}

	$('#header .customer-service-link button, .header-drop .customer-service-link button').on('click mouseenter', function(e){
		e.preventDefault();
		e.stopPropagation();
		var menu = $(this).parent().find('.customer-service-dropdown');

		if (!menu.hasClass('has-appeared')) {
			if(menu.is(':visible')){
				menu.fadeOut(300);
			}else{
				menu.fadeIn(300);
			}

			menu.addClass('has-appeared');

			setTimeout(() => {
				menu.removeClass('has-appeared');
			}, 300);

			$(document).click(function(event){

				if(!$(event.target).attr('class') != 'customer-service-dropdown') {
					menu.fadeOut(300)
				}
			});
		}
	});

	$('.customer-service-dropdown').on('mouseleave', function() {
		const $this = $(this);

		if (!$this.hasClass('has-appeared')) {
			if ($(this).is(':visible')) {
				$(this).fadeOut(300);
			} else {
				$(this).fadeIn(300);
			}
		}
	})
});

function validateEmail(email) {
	var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
	return re.test(email);
}

/**
* Page-specific call-backs
* Called after dom has loaded.
*/
var RADIANCE = {

	common : {
		init: function(){
			$('html').removeClass('no-js').addClass('js');
			setupDropdownMenus();

			$('.nav-arrow', '#top-menu').each( function(){
				$(this).css('top', Math.ceil($(this).parent(2).height()/2) + 1);
			});

		}
	},

	templateIndex : {
		init: function(){

		}
	},

	templateProduct : {
		init: function(){
			//$('#product-actions').bind( 'submit', addToCart );
			$('#thumbs li:nth-child(5n+5)').addClass('last-in-row');
		}
	},

	templateCart : {
		init: function(){
			var checkInstructionsNote = function() {
				if($('#chk-is-instructions').is(':checked')) {
					$('#is-instructions').val('Yes');
					$('#instructions-note').show();
				} else {
					$('#is-instructions').val('No');
					$('#instructions-note').hide();
					$('#instructions-note').find('textarea').val("");
				}
			}
			$('#chk-is-instructions').click(function(){
				checkInstructionsNote();
			});
			checkInstructionsNote();
		}
	}

}

var UTIL = {

	fire : function(func,funcname, args){
		var namespace = RADIANCE;
		funcname = (funcname === undefined) ? 'init' : funcname;
		if (func !== '' && namespace[func] && typeof namespace[func][funcname] == 'function'){
			namespace[func][funcname](args);
		}
	},

	loadEvents : function(){
		var bodyId = document.body.id;

		// hit up common first.
		UTIL.fire('common');

		// do all the classes too.
		$.each(document.body.className.split(/\s+/),function(i,classnm){
			UTIL.fire(classnm);
			UTIL.fire(classnm,bodyId);
		});
	}

};
$(document).ready(UTIL.loadEvents);

/**
* Support for dropdown menus
*/
function setupDropdownMenus(){

	var config = {
		over: function () {
			$(this).find('.submenu:first').slideDown();
		},
		timeout: 400,
		out: function () {
			$(this).find('.submenu:first').slideUp();
		}
	};
	$('.main-menu .has-dropdown').hoverIntent(config);

	$(document).on('keydown', '.main-menu .has-dropdown a:focus', function(e){
		if (e.which == 32) { //Spacebar
			e.preventDefault();
			$(this).next().slideToggle();
		}
		if (e.which == 40) { //Arrow Down
			e.preventDefault();
			$(this).next().slideDown();
		}
		if (e.which == 38) { //Arrow Up
			e.preventDefault();
			$(this).next().slideUp();
		}
	});

	$(document).on('keydown', '.main-menu .has-dropdown .has-dropdown a:focus', function(e){
		if (e.which == 39) { //Arrow Right
			e.preventDefault();
			$(this).next().slideDown();
		}
		if (e.which == 37) { //Arrow Left
			e.preventDefault();
			$(this).next().slideUp();
		}
	});

	$(document).on('keydown', '.compression-levels li:focus', function(e){
		if (e.which == 32) { //Spacebar
			e.preventDefault();
			$(this).addClass('selected active');
			$(this).find('.popup').addClass('fadeInDown');
		}
	});

	$(document).on('keydown', '.utilityLink a:focus', function(e){
		if (e.which == 32) { //Spacebar
			e.preventDefault();
			$('toOpen').toggleClass('hide ');
		}
	});

	$(document).on('click', '.utility-bar .left-message a', function(){
		$(this).siblings('.shipping-popup').slideToggle();
		return false;
	});
	$(document).click(function(event){
		if(!$(event.target).closest('.left-message').length) {
			$('.shipping-popup').slideUp();
		}
	});
	$(document).on('click', '.customer-service-link button', function(){
		$(this).siblings('.customer-service-dropdown').slideToggle();
		//return false;
	});
	$(document).click(function(event){
		if(!$(event.target).closest('.customer-service-link').length && $(window).width() > 900) {
			$('.customer-service-dropdown').slideUp();
		}
	});
	$(document).on('keydown', '.customer-service-link button:focus', function(e){
		if (e.which == 32) { //Spacebar
			e.preventDefault();
			$(this).siblings('.customer-service-dropdown').slideToggle();
		}
		if (e.which == 40) { //Arrow Down
			e.preventDefault();
			$(this).siblings('.customer-service-dropdown').slideDown();
		}
		if (e.which == 38) { //Arrow Up
			e.preventDefault();
			$(this).siblings('.customer-service-dropdown').slideUp();
		}
	});


	$('.header-drop a').attr({'focusable':'false','tabindex':'-1'});

}

function getQueryParam(name, url) {
	if (!url) url = window.location.href;
	name = name.replace(/[\[\]]/g, "\\$&");
	var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
	results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function openModal(content) {
	modal = new tingle.modal({
		closeMethods: ['overlay', 'button', 'escape'],
		closeLabel: "Close"
	});
	modal.setContent(content);
	modal.open();
}

function cookiesDisclaimer() {
	$.get("https://ipinfo.io", function(response) {
	if(response.country == "AT" || response.country == "BE" || response.country == "BG" || response.country == "HR" || response.country == "CY" || response.country == "CZ" || response.country == "DK" || response.country == "EE" || response.country == "FI" || response.country == "FR" || response.country == "DE" || response.country == "GR" || response.country == "HU" || response.country == "IE" || response.country == "IT" || response.country == "LV" || response.country == "LT" || response.country == "LU" || response.country == "MT" || response.country == "NL" || response.country == "PL" || response.country == "PT" || response.country == "RO" || response.country == "SK" || response.country == "SI" || response.country == "ES" || response.country == "SE" || response.country == "GB" ) {
		if (localStorage.getItem('cookies_accepted')!='1') {
			var $div = $('#cookies-disclaimer')
			$div.find('.btn-accept').click(function(){
				localStorage.setItem('cookies_accepted', '1');
				$div.fadeOut();
			});
			$div.find('.btn-cancel').click(function(){
				$div.fadeOut();
			});
			$div.fadeIn();
		}
	}
}, "jsonp");
}


// Pepperjam Click ID Tracking



$(function() {
	/* Reduced motion: Replace slideToggle(), slideDown(), slideUp() with toggle(), show(), hide() */
	var oSlideToggle = jQuery.fn.slideToggle;
	jQuery.fn.slideToggle = function() {
		if(Simplistic.reducedMotion()){
			return jQuery.fn.toggle.apply(this, arguments);
		}else{
			return oSlideToggle.apply(this, arguments);
		}
	};
	var oSlideDown = jQuery.fn.slideDown;
	jQuery.fn.slideDown = function() {
		if(Simplistic.reducedMotion()){
			return jQuery.fn.show.apply(this, arguments);
		}else{
			return oSlideDown.apply(this, arguments);
		}
	};
	var oSlideUp = jQuery.fn.slideUp;
	jQuery.fn.slideUp = function() {
		if(Simplistic.reducedMotion()){
			return jQuery.fn.hide.apply(this, arguments);
		}else{
			return oSlideUp.apply(this, arguments);
		}
	};
	/* End of Reduced Motion */
});

window.SimplisticJS = function (){
	this.beforeTrapFocus = false;

	/**
	* Traps the focus in a particular container
	*
	* @param {object} options - Options to be used
	* @param {jQuery} options.$container - Container to trap focus within
	* @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
	* @param {string} options.namespace - Namespace used for new focus event handler
	*/
	this.trapFocus = function(options) {
		this.beforeTrapFocus = $(':focus');
		var eventName = options.namespace
		? 'focusin.' + options.namespace
		: 'focusin';

		if (!options.$elementToFocus) {
			options.$elementToFocus = options.$container;
		}

		options.$container.attr('tabindex', '-1');
		options.$elementToFocus.focus();

		$(document).on(eventName, function(evt) {
			if ( options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
				options.$container.focus();
			}
		});
	},

	/**
	* Removes the trap of focus in a particular container
	*
	* @param {object} options - Options to be used
	* @param {jQuery} options.$container - Container to trap focus within
	* @param {string} options.namespace - Namespace used for new focus event handler
	*/
	this.removeTrapFocus = function(options) {
		var eventName = options.namespace
		? 'focusin.' + options.namespace
		: 'focusin';

		if (options.$container && options.$container.length) {
			options.$container.removeAttr('tabindex');
		}
		if(this.beforeTrapFocus) {
			this.beforeTrapFocus.focus();
			this.beforeTrapFocus = false;
		}

		$(document).off(eventName);
	}

	this.handleize = function (str) {
		//source https://gist.github.com/dlindenkreuz/a439ec4b939f0561d6d9
		return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
	};

	this.reducedMotion = function() {
		return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	};
};
window.Simplistic = new SimplisticJS();
